import "../App.css";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import useThemeColor from "../hooks/TopBarColorWheel";
import useContainerHeight from "../hooks/useContainerHeight";
import { API_BASE } from "../apiBase";

const POLL_INTERVAL_MS = 3000;

export function PaymentPendingPage() {
  const { t } = useTranslation();
  useThemeColor();
  const containerHeight = useContainerHeight();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const reference = searchParams.get("reference");

  useEffect(() => {
    if (!reference) {
      navigate("/payment-error", { replace: true });
      return;
    }

    let cancelled = false;
    const ref = encodeURIComponent(reference);

    // Once Vipps settles, the server's /redirect routes this tab back into
    // the room, the same way it does when Vipps returns right away.
    const poll = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/payment-status/${ref}`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const { state } = await res.json();
        if (cancelled || state === "CREATED") return;
        window.location.replace(`${API_BASE}/redirect?reference=${ref}`);
      } catch (err) {
        console.error("Payment status poll failed:", err);
      }
    };

    poll();
    const id = setInterval(poll, POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [reference, navigate]);

  return (
    <div className="App" style={{ height: containerHeight - 48 }}>
      <div
        className="App-header"
        style={{ justifyContent: "center", textAlign: "center" }}
      >
        <p className="text-h1">{t("payment.status.pending")}</p>
        <p className="text-h1 top-margin-m">{t("payment.status.dontClose")}</p>
      </div>

      <div className="background"></div>
    </div>
  );
}
